module.exports = __webpack_public_path__ + "static/media/diet_unselected.5d1e5bf2.svg";